<template>
  <AcceptingDialog
    ref="accepting_dialog"
    :acceptors="acceptors"
    :btn_text="$t('Catalog.Send')"
    :close="close"
    :disabled_open="disabled"
    :load_acceptors="load_acceptors"
    :loading="loading"
    :second-btn-action="saveAsTemplate"
    :send-action="saveApplication"
    :submit="submit"
    :title=" $t('Catalog.ThankYou') + ' #' + purchase.number + ' ' + $t('Catalog.Sent') "/>
</template>
<script>
import AcceptingDialog from 'components/common/dialogs/AcceptingDialog.vue'

import ApplicationsApi from '@/api/applicationApi'
import FavoritesApi from '@/api/favoritesApi'


const fav_api = new FavoritesApi()
const api = new ApplicationsApi()
export default {
  name: 'createdPurchaseDialog',
  data() {
    return {
      dialog: false,
      loading: false,
      load_acceptors: false,
      without_accept: false,
      acceptors: []
    }
  },
  props: {
    purchase: Object,
    changed: Function
  },
  computed: {
    disabled() {
      return !this.purchase?.rows?.length || !this.purchase?.rows?.every(el => {
        return !!(el.declaredQuantity && (el.declaredSupplyDate || el.declaredPriority.id) )
      })
    }
  },
  methods: {
    submit() {
      this.close()
    },
    async saveApplication() {
      this.loading = true
      if ( this.changed() ) {

        await api.editApplication({
          'id': this.purchase.id,
          'title': this.purchase.title,
          'receiverId': this.purchase.receiver ? this.purchase.receiver.id  || this.purchase.receiver.organizationItId : null
        })
      }

      if (this.purchase.state == 'П') {
        this.load_acceptors = true
        await (api.sendApplication(this.purchase.id)
          .catch( er => this.$log_error(er)))
          .then(res => {
            if ( this.$can('have', 'AgreementsProcess') ) {
              this.without_accept = true
            } else {
              this.acceptors = res.data.sendApplication.reverse()
            }
            this.$refs.accepting_dialog.open()
            return

          })
          .finally( () => this.load_acceptors = false)
      }
      this.loading = false
    },
    close() {
      this.$refs.accepting_dialog.closeDialog(true)
      this.$router.push({name: 'purchasing', params: {org: this.$route.params.org} })
    },

    saveAsTemplate() {
      fav_api.addToFavorite(this.purchase.id)
    },
  },
  components: {
    AcceptingDialog
  }
}
</script>
